<div class="help-page__header help-page__header--sub-header">
  {{ 'help-page.contact-text' | translate }}
</div>
<div (click)="closeContact()" class="icon-close help-page__content--close-button" genericButton></div>
<div class="help-page__content" [innerHTML]="empSpecificContents.contact"></div>
